module.exports = __webpack_public_path__ + "static/media/document.fd1b2aa8.png";